import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./ServicesHeroSection.css";
import "./FAQ.css";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const servicesList = [
    {
    title: "Irritable Bowel Syndrome (IBS)",
    img: "https://i.ibb.co/CKbPKvbx/Image-Placeholder-2.png",
    description:
      "Comprehensive treatment plans for irritable bowel syndrome (IBS).",
  },
  {
    title: "Peptic Ulcer Disease",
    img: "https://i.ibb.co/YBsgM3W3/Container.png",
    description: "Effective care and monitoring for peptic ulcer disease.",
  },
  {
    title: "Acute Gastroenteritis",
    img: "https://i.ibb.co/sJX1xtb7/Image-Placeholder-3.png",
    description:
      "Rapid diagnosis and treatment for acute gastroenteritis symptoms.",
  },
  {
    title: "Hemorrhoids",
    img: "https://i.ibb.co/7NZrPq8G/Image-Placeholder-4.png",
    description: "Non-invasive and surgical treatments for hemorrhoids.",
  },
  {
    title: "Upper GI Endoscopy",
    img: "https://i.ibb.co/JWh3XBHV/image-7.png",
    description:
      "Endoscopy is a simple minimally invasive procedure that can help diagnose the cause of digestive symptoms ,anemia , inflammation,weight loss ,diarrhoea  and other similar conditions .It helps your gastroenterologist to examine your esophagus , stomach and the duodenum ",
  },
  {
    title: "Colonoscopy",
    img: "https://i.ibb.co/zTBWZ64m/image-4-1.png",
    description:
      "Colonoscopy procedure involves examination of your colon and terminal portion of your small intestine.Colonoscopy is minimally invasive and can be performed under sedation making it totally painless .It can help diagnose the root cause of symptoms like abdominal pain , chronic diarrhoea, constipation, blood in the stool etc .It is also the simplest and most effective screening tool for prevention and early diagnosis of colon cancer ",
  },
  {
    title: "ERCP (Endoscopic Retrograde Cholangiopancreatography)",
    img: "https://i.ibb.co/LXx1Gbqp/image-4-2.png",
    description:
      "ERCP is an endoscopic procedure that uses endoscopic and fluoroscopic guidance to treat diseases of the bile duct and pancreatic duct",
  },
  {
    title: "Endoscopic Ultrasound (EUS)",
    img: "https://i.ibb.co/3mDfjKBY/image-4-5.png",
    description:
      "Endoscopic ultrasound is a procedure that combines endoscopy and ultrasound to create images of the digestive tract and nearby organs and tissues. It is one of the best modalities for the diagnosis and management of pancreaticobiliary disease EUS enables the gastroenterologist to take biopsies and samples from the digestive tract and also other organs in close proximity to the GI wall",
  },
  {
    title: "Liver Disease Management",
    img: "https://i.ibb.co/wN7rxTCD/image-4-3.png",
    description:
      "Comprehensive care for liver problems such as hepatitis, fatty liver, cirrhosis, and liver cancer.",
  },
  {
    title: "Capsule Endoscopy",
    img: "https://i.ibb.co/XxpFM7v0/image-4-4.png",
    description:
      "Capsule endoscopy is a procedure that uses a tiny wireless camera to take pictures of the digestive tract. A capsule endoscopy camera sits inside a vitamin-sized capsule that has to be swallowed. The camera takes thousands of pictures that are sent to a recorder worn on a belt around the waist.",
  },
  {
    title: "24-hour pH Monitoring",
    img: "https://i.ibb.co/XrGXqwS6/image-4-6.png",
    description:
      "This is a procedure which measures how often fluid refluxes (flows back) into your oesophagus from your stomach and the pH of this fluid over a 24-hour period. This procedure helps your doctor to confirm and assess the severity of your GERD problem.Based on these results your doctor can then recommend a endoscopic or surgical treatment option for those patients with refractory GERD ( Gastro esophageal reflux disease)",
  },
  {
    title: "Manometry Testing",
    img: "https://i.ibb.co/WW7BgRYd/image-4-7.png",
    description:
      "The purpose of high-resolution esophageal manometry is to measure the pressures in your esophagus when you are resting and when you swallow. These pressures will tell us if your esophagus is working normally. The most common uses for the test are to: Diagnose esophageal motility disorders like achalasia cardia",
  },
  {
    title: "Balloon Enteroscopy",
    img: "https://i.ibb.co/kVkwbDrN/image-4-8.png",
    description:
      "Balloon enteroscopy is a nonsurgical procedure. It's performed using a long thin tube with a balloon and a camera at the tip to assess your small intestine. It is a major procedure requiring in patient care .It helps the gastroenterologist to dignose cause of small bowel ulcers , Crohns disease , cause of occult bleeding etc",
  },
  {
    title: "Hepatitis Screening & Vaccination",
    img: "https://i.ibb.co/k2XzDfHP/image-4-9.png",
    description:
      "Screening for hepatitis viruses and vaccination to prevent liver-related complications.",
  },
  {
    title: "H. Pylori  Test",
    img: "https://i.ibb.co/SwZJrpL3/image-4-10.png",
    description:
      "A quick, non-invasive test to detect H. pylori infection, a major cause of ulcers.",
  },
  {
    title: "Colon Cancer Screening",
    img: "https://i.ibb.co/WW7BgRYd/image-4-7.png",
    description:
      "Colon cancer screening is a vital preventive measure that helps detect early signs of colorectal cancer and precancerous growths. By identifying issues at an early stage, screening greatly improves treatment outcomes and reduces the risk of advanced disease. Doctors recommend regular screening starting at age 45, or earlier for those with a family history or other risk factors.",
  },
  {
    title: "Fatty Liver Disease Treatment",
    img: "https://i.ibb.co/3yGC9RLF/image-4-12.png",
    description:
      "Advanced treatment for fatty liver disease with lifestyle guidance and medical care.",
  },
];
const faqs = [
  {
    question:"How much does an upper GI endoscopy cost at Krisara Gastro in Hyderabad?",
    answer:"Our endoscopy pricing is competitive and transparent. Contact us at +91-9959981290 for exact quotes and insurance coverage details.",
  },
  {
    question:"Is endoscopy painful? What can I expect at Krisara Gastro?",
    answer:"All our endoscopy procedures use conscious sedation, making them completely painless. Dr. Shruti Sagar's expertise ensures comfortable, safe procedures with quick recovery.",
  },
  {
    question:"How long does an upper endoscopy take at Krisara Gastro?",
    answer:"Upper endoscopy typically takes 15–30 minutes. Including preparation and recovery, plan for 2–3 hours total at our Kompally clinic.",
  },
  {
    question:"At what age should I get my first colonoscopy screening?",
    answer:"We recommend colonoscopy screening at age 45, or earlier if you have family history, symptoms, or risk factors for colon cancer.",
  },
  {
    question:"How much does a colonoscopy cost at Krisara Gastro in Hyderabad?",
    answer:"Our colonoscopy pricing is competitive with special packages available. Contact +91-9959981290 for current rates and insurance coverage.",
  },
  {
    question:"Is colonoscopy painful at Krisara Gastro?",
    answer:"No. Colonoscopy is performed under conscious sedation, making it completely painless. Most patients don’t remember the procedure and recover quickly.",
  },
  {
    question:"Can polyps be removed during colonoscopy?",
    answer:"Yes. Dr. Sagar can remove polyps during colonoscopy using advanced techniques, preventing potential cancer development.",
  },
  {
    question:"What conditions require ERCP treatment at Krisara Gastro?",
    answer:"ERCP treats bile duct stones, tumors, strictures, chronic pancreatitis, and pancreatic duct injuries with high success rates.",
  },
  {
    question:"How experienced is Dr. Shruti Sagar with ERCP procedures?",
    answer:"Dr. Sagar has successfully completed 500+ ERCP procedures, making him one of Hyderabad’s most experienced ERCP specialists.",
  },
  {
    question:"Can EUS detect pancreatic cancer early?",
    answer:"Yes. Endoscopic Ultrasound (EUS) is extremely sensitive for detecting pancreatic cancer and masses. It also allows guided biopsies for accurate diagnosis.",
  },
  {
    question:"Is EUS better than CT scan or MRI?",
    answer:"EUS provides superior resolution for pancreaticobiliary diseases and allows real-time tissue sampling, making it more accurate than CT/MRI.",
  },
  {
    question:"What liver diseases does Krisara Gastro treat in Hyderabad?",
    answer:"We treat fatty liver, hepatitis B & C, cirrhosis, autoimmune liver diseases, and provide liver cancer surveillance with advanced diagnostics.",
  },
  {
    question:"Do you provide hepatitis B and C treatment?",
    answer:"Yes. We offer the latest antiviral treatments for hepatitis B and C with cure rates above 95% for hepatitis C.",
  },
  {
    question:"Do you handle GI emergencies in Kompally, Hyderabad?",
    answer:"Yes. We provide 24/7 emergency consultations for abdominal pain, GI bleeding, and other urgent digestive issues with immediate endoscopy availability.",
  },
  {
    question:"Do you offer capsule endoscopy in Hyderabad?",
    answer:"Yes. We provide capsule endoscopy for small bowel evaluation, Crohn’s disease diagnosis, and obscure bleeding detection.",
  },
];
const ServicePopup = ({ isOpen, onClose, service, navigate }) => {
  if (!isOpen || !service) return null;
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="popup-container"
        style={{ height: "60%" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Left Image */}
        <div className="popup-image">
          <img src={service.img} alt={service.title} />
        </div>
        {/* Right Info */}
        <div className="popup-form">
          <h2 style={{ fontSize: "24px", marginBottom: "4px",marginTop:"50px" }}>
            {service.title}
          </h2>
          <p
            style={{
              fontSize: "16px",
            }}
          >
            {service.description}
          </p>
          {/* Book Appointment Button */}
          <button
            className="orange"
            style={{
              display: "inline-block",
              padding: "12px 24px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#fff",
              background: "linear-gradient(90deg, #ff7e5f, #feb47b)",
              border: "none",
              borderRadius: "20px",
              cursor: "pointer",
              margin: "50px",
              width: "70%",
            }}
            onClick={() => {
              navigate("/appointment");
              onClose(); // ✅ close popup after redirect
            }}
          >
            Book Appointment
          </button>
        </div>
      </div>
    </div>
  );
};
export default function ServicesHeroSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const sectionRef = useRef(null);
  const navigate = useNavigate();
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
  return (
    <>
      {/* Services Section */}
      <section className="services-hero-section">
        <h2 className="services-hero-title">
          Services at Krisara Gastro and Liver Clinic
        </h2>
        <p className="services-hero-subtitle">
          Comprehensive Digestive &amp; Liver Care in Kompally, Hyderabad
        </p>
        <div className="services-hero-grid">
          {servicesList.map((service, index) => (
            <motion.div
              className="services-hero-card"
              key={index}
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <img
                src={service.img}
                alt={service.title}
                className="services-hero-image"
              />
              <div className="services-hero-card-footer">
                <p className="services-hero-text">{service.title}</p>
                <button
                  className="services-hero-arrow"
                  onClick={() => setSelectedService(service)}
                >
                  →
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
      {/* Service Info Popup */}
      <ServicePopup
        isOpen={!!selectedService}
        onClose={() => setSelectedService(null)}
        service={selectedService}
        navigate={navigate}
      />
      {/* FAQ Section */}
      <section
        ref={sectionRef}
        className={`faq-container ${isVisible ? "animate" : ""}`}
      >
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
        <h2 className="faq-title fade-up" style={{ transitionDelay: "0.2s" }}>
          Frequently Asked Questions
        </h2>
        <p className="faq-subtitle fade-up" style={{ transitionDelay: "0.4s" }}>
          Answers to the most common queries about our gastro and liver services
          in Kompally, Hyderabad. Explore guidance below or contact us for
          support.
        </p>
       <a href="tel:+917569541532">
  <button
    className="faq-button fade-up"
    style={{ transitionDelay: "0.6s" }}
  >
    Reach Out to Us
  </button>
</a>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item fade-up"
              style={{ transitionDelay: `${0.6 + index * 0.1}s` }}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>
              {openIndex === index && (
                <motion.div
                  className="faq-answer fade-in"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  transition={{ duration: 0.4 }}
                >
                  <p>{faq.answer}</p>
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}